import { useState } from 'react';
import clsx from 'clsx';
import { Button, FormControl } from '@mui/material';
import { ReactComponent as ContentCopy } from 'assets/images/copy.svg';
import DoneIcon from '@mui/icons-material/Done';

import styles from './styles.module.scss';
import { InputStyled } from '../Form/InputStyled';
import * as React from 'react';

type InputProps = {
  copyText: string;
  label: string;
  isActive: boolean;
  isTransparent?: boolean;
};

function ClipboardCopy({
  copyText,
  label,
  isActive = false,
  isTransparent = false,
}: InputProps) {
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    if (isActive) {
      copyTextToClipboard(copyText)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div className={styles.root}>
      <FormControl sx={{ m: 0, p: 0, width: '100%' }}>
        <InputStyled
          className={clsx(
            styles.copyInput,
            isCopied && styles.successInput,
            isTransparent && styles.transparent
          )}
          value={copyText}
          onChange={() => null}
          readOnly={true}
          disabled={!isActive}
          label={label}
        />
        <Button
          className={styles.copyButton}
          startIcon={!isCopied ? <ContentCopy /> : <DoneIcon />}
          disabled={!isActive}
          onClick={handleCopyClick}
        ></Button>
      </FormControl>
    </div>
  );
}

export default ClipboardCopy;
